<style scoped>

</style>
<template>
  <div>
    <div class="line text-center">
      <!--<Button type="primary" icon="md-add" @click="editNewTravelOrder">添加出行订单</Button>-->
      <div
        v-if="false"
        class="search-input"
      >
        <!-- @on-change="selectorNewOne" -->
        <i-input
          v-model="params.search"
          placeholder="输入关键字搜索"
          @on-enter="doSearch()"
        />
      </div>
      <Ajaxbtn
        v-show="false"
        ref="searchBtn"
        :url="get_travel_orders_path"
        :params="params"
        type="search"
        @before="beforeSearch"
        @done="handleData"
        @fail="handleFail"
      />
    </div>
    <Table
      :columns="columns"
      :data="travel_orders"
      :loading="loading"
    />
    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
      <Button
        style="position: absolute; top: 4px; right: 30px"
        type="primary"
        @click="exportOrder"
      >
        导出行程数据
      </Button>
    </div>
    <TravelOrderEdit
      ref="editor"
      @update="updateTravelOrder"
    />
  </div>
</template>
<script route="/exec/travel_order">
  import Util from '../../libs/util';
  import FlowUtil from '../../libs/flow_util';
  import TravelOrderExpand from '../reservation/components/travel_order_expand';
  import TravelOrderBase from '../reservation/mixins/travel_order_base';
  export default {
    /* router_info_start */
    router_info: '/exec/travel_order',
    /* router_info_end */
    components: { TravelOrderExpand },
    mixins: [TravelOrderBase],
    data() {
      return {
        get_travel_orders_path: Util.api.query_travel_order,
        expand_column: {
          title: '展开',
          type: 'expand',
          align: 'center',
          width: 60,
          render: (h, params) => {
            return h(TravelOrderExpand, {
              props: {
                travel_order: params.row,
                show_handles: true
              }
            })
          }
        },
        handle_column:  {
          title: '操作',
          width: 85,
          align: 'center',
          render: (h, params) => {
            return h('span', '-');
            const row = params.row;
            const items = [];
            items.push(h('DropdownItem', {
              props: {name: 'edit'}
            }, '编辑'));
            items.push(h('DropdownItem', {
              props: {name: 'delete', divided: true}
            }, '废弃'));
            return h('Dropdown', {
              props: {
                trigger: 'click',
                placement: 'left'
              },
              on: {
                'on-click': (event_name) => {
                  this.handleEvent(event_name, row, params.index);
                }
              }
            }, [
              h('Button', [
                h('span', ' 操作'),
              ]),
              h('DropdownMenu', {
                slot: 'list'
              }, items)
            ]);
          }
        }
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
    },
    created() {
      //
    },
    mounted() {
      this.doSearch();
    },
    methods: {
      exportOrder() {
        window.open(Util.api.export_travel_order, '_blank');
      },
    }
  }
</script>
